import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { TRIAL_LENGTH } from "../config";

export const setCookie = (c_name, value, exdays) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
}

export const getCookie = (c_name) => {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}

export const openInNewTab = (url) => {
    const win = window.open(url, '_blank');
    if (win != null) {
        win.focus();
    }
}


export const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
}

export const isEmail = (email) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return (email.match(regex)) ? true : false
}

export const uniqueId = (length = 3) => {
    // return Math.floor(Math.random() * (length*100))
    return Math.random().toString().slice(2, (length + 2))
}

export const getQueryParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}

export const setQueryParam = (key, value) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key, value);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
}
export const removeQueryParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(key);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
}


export const splitAndTrim = (string, splitOn = ',') => {
    if (string.indexOf(splitOn) > -1) {
        const items = string.split(splitOn);
        const formatted = items.map(tag => tag.replace(/ /g, ''))
        return formatted;
    } else {
        return [string];
    }
}

export const fullName = (user) => {
    return `${user.firstName} ${user.lastName}`;
}

export const isPaymentPastDue = (account) => {
    return (account?.paymentStatus === 'pastdue') ? true : false;
}

export const hasPaymentFailed = (account) => {
    return (account?.paymentStatus === 'failed') ? true : false;
}

export const isAccountCanceled = (account) => {
    return (account?.subscriptionStatus === 'canceled') ? true : false;
}

export const restrictAccessBecauseOfPayment = (account) => {
    if (hasPaymentFailed(account)) return true;
    if (isAccountCanceled(account)) return true;
    return false;
}

export const isPayingCustomer = (account, validPlans) => {

    // No Account: Get Account
    if (!account) return false;

    // Fails if no plan
    if (!account?.plan) return false;

    // Split. No idea why I didn't make this an array.
    const plans = validPlans?.split('|');

    // Get Current Plan
    const accountPlan = account?.plan.toLowerCase();

    // Validate The Account isn't Canceled or Failing too many payments
    if (restrictAccessBecauseOfPayment(account)) return false;

    // Check if account has access
    const plan = plans.filter(plan => {
        if (plan.toLowerCase() === accountPlan) return plan;
        return false;
    })

    if (plan?.length > 0) return true;
    return false;
}

export const isFreeTrial = (account) => {

    // Set Trial End Date
    let trialEnds;
    if (account?.meta?.trialEnds) {
        trialEnds = moment(account?.meta?.trialEnds).format('YYYYMMDD');

    } else {
        trialEnds = moment(account?.createdAt).add(TRIAL_LENGTH, 'd').format('YYYYMMDD');

    }

    // Calculate
    const now = moment().format('YYYYMMDD');
    return (now > trialEnds) ? false : true;
}

export const dayRemainingOnFreeTrial = (account) => {
    let trialEnds;
    if (account?.meta?.trialEnds) {
        trialEnds = moment(account?.meta?.trialEnds).format('YYYYMMDD');
    } else {
        trialEnds = moment(account?.createdAt).add(TRIAL_LENGTH, 'd').format('YYYYMMDD');
    }

    // Calculate
    const now = moment().format('YYYYMMDD');
    var start = moment(trialEnds, "YYYY-MM-DD");
    var end = moment(now, "YYYY-MM-DD");

    //Difference in number of days
    const diff = moment.duration(start.diff(end)).asDays();
    if (diff <= 0) return 0;
    return parseInt(diff);

}

export const loadScript = (src, position, id) => {
    if (!position) return;

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.src = src;
    position.appendChild(script);
}

export const postMessage = (action, data) => {
    let targetWindow = (!window.parent) ? window : window.parent;
    if (window?.ReactNativeWebView) targetWindow = window.ReactNativeWebView;
    const a = JSON.stringify({ action, data });
    targetWindow.postMessage(a, '*')
}

export const isStripeSubscription = (subId) => {
    // TODO: This isn't perfect.
    return (subId.indexOf('sub_') > -1) ? true : false;
}

export const isNativeApp = () => {
    return (window?.ReactNativeWebView) ? true : false;
}

export const storeWithExpiry = async (key, value, minutes) => {
    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + (minutes * 60000),
    }
    window.localStorage.setItem(key, JSON.stringify(item))
    return item;
}

export const loadWithExpiry = async (key) => {
    const itemStr = window.localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)

    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        window.localStorage.removeItem(key)
        return null
    }
    return item.value
}

export const useOnScreen = (rootMargin = "0px") => {
    const [isIntersecting, setIntersecting] = useState(false);
    const [onScreenReady, setOnScreenReady] = useState(false);
    const ref = useRef()
    useEffect(() => {

        if (onScreenReady !== true) return;
        const observer = new IntersectionObserver(([entry]) => { setIntersecting(entry.isIntersecting); },
            { rootMargin }
        );
        if (ref.current) observer.observe(ref.current);
        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };
    }, [onScreenReady]); // Empty array ensures that effect is only run on mount and unmount
    return {
        isIntersecting,
        onScreenReady,
        setOnScreenReady,
        onScreenRef: ref
    }
}

export const camelCaseToWords = (text) => {
    const result = text.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
}

export const useKeyPress = (targetKey) => {
    // State for keeping track of whether key is pressed
    const [keyPressed, setKeyPressed] = useState(false);
    // If pressed key is our target key then set to true
    function downHandler({ key }) {
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }
    // If released key is our target key then set to false
    const upHandler = ({ key }) => {
        if (key === targetKey) {
            setKeyPressed(false);
        }
    };
    // Add event listeners
    useEffect(() => {
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return keyPressed;
}